import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Card, CardText } from 'reactstrap';
import { Link } from 'react-router-dom';

import ComponentCard from '../../components/ComponentCard';

const AirtelPaymentClienStateheadPending = () => {
  const [activeTab, setActiveTab] = useState('3');
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
//   const user = JSON.parse(localStorage.getItem('user'));
  const fetchTabData = async (tab) => {
    const vendorName = "DENTSU COMMUNICATIONS";
    setLoading(true);
    setError(null);
    let api = `https://api.outdoorooh.com/api/fresh-site-vendor-project/${vendorName}`;

    if (tab === '2') {
      api = `https://api.outdoorooh.com/api/fresh-site-vendor-approved-sites/${vendorName}`;
    } else if (tab === '3') {
      api = `https://api.outdoorooh.com/api/fresh-site-vendor-pending-sites/${vendorName}`;
    } else if (tab === '4') {
      api = `https://api.outdoorooh.com/api/fresh-site-vendor-rejected-sites/${vendorName}`;
    } else if (tab === '5') {
      api = `https://api.outdoorooh.com/api/fresh-site-asm-rejected-site-for-vendor/${vendorName}`;
    }

    try {
      const response = await fetch(api);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setData(result.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      fetchTabData(tab);
    }
  };
   const filteredData = data.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.site_name?.toLowerCase().includes(term) ||
      item.code?.toLowerCase().includes(term)||
      item.state?.toLowerCase().includes(term)||
      item.zone?.toLowerCase().includes(term)

    );
  });
  useEffect(() => {
    fetchTabData(activeTab);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
         <div className="d-flex justify-content-end mb-3">
  <input
    type="text"
    className="form-control p-2"
    placeholder="Search here"
    style={{ maxWidth: '300px' }}
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>
      <ComponentCard title="Honda campaign Vendor Projects">
        <Nav tabs>
          
          <NavItem>
            <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => toggle('3')}>
              Pending
            </NavLink>
          </NavItem>
          
        </Nav>
        <TabContent className="p-4" activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              {filteredData.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                   
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                    
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                              <Link
                      to={`/airtel-payment-project-detail/${item.id}`}
                    >
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://api.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                            </Link>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-payment-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                  <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://api.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-payment-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                  <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.new_image, item.new_image1, item.new_image2, item.new_image3, item.new_image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://api.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.new_image, item.new_image1, item.new_image2, item.new_image3, item.new_image4].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-payment-vendor-pending/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                  <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://api.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-payment-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>

          <TabPane tabId="5">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                  <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://api.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-payment-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
        </TabContent>
      </ComponentCard>
    </>
  );
};

export default AirtelPaymentClienStateheadPending;
